import * as Yup from "yup";

const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;

export const step1Schema = Yup.object({
  companyName: Yup.string().trim().required("Company name is required"),
  companyDomain: Yup.string()
    .trim()
    .matches(domainRegex, "Enter a domain like acme.com")
    .required("Company domain is required"),
  senderEmail: Yup.string()
    .trim()
    .email("Enter a valid email")
    .required("Sender email is required"),
});

export const step2Schema = Yup.object({
  oktaDomain: Yup.string()
    .trim()
    .matches(domainRegex, "Enter an Okta domain like example.okta.com")
    .required("Okta domain is required"),
  oktaClientID: Yup.string().trim().required("Okta client ID is required"),
  sfUsername: Yup.string()
    .trim()
    .email("Salesforce usernames are typically an email")
    .required("Salesforce username is required"),
  sfPassword: Yup.string().required("Salesforce password is required"),
  sfSecurityToken: Yup.string()
    .trim()
    .required("Salesforce security token is required"),
});

export const step3Schema = Yup.object({
  documentTypes: Yup.array().of(Yup.string()),
  mediaChannels: Yup.array().of(Yup.string()),
  geographies: Yup.array().of(Yup.string()),
  priorities: Yup.array().of(Yup.string()),
});

export const fullSchema = step1Schema.concat(step2Schema).concat(step3Schema);
